var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeTipDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.75L8.25 6.75L8.25 5.25L9.75 5.25L9.75 6.75ZM9.75 12.75L8.25 12.75L8.25 8.25L9.75 8.25L9.75 12.75ZM9.0075 16.5C13.1475 16.5 16.5 13.14 16.5 9C16.5 4.86 13.1475 1.5 9.0075 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9.0075 16.5ZM9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeTipDark);
export default __webpack_public_path__ + "static/media/exchange_tip_dark.aa62da7ec1dc402e18900e75f433802d.svg";
export { ForwardRef as ReactComponent };